import React, { Fragment,useCallback,useState } from "react";
import {
  Filter,
  ReferenceInput,
  AutocompleteInput,
  SelectInput,
  LongTextInput,
  TextInput,
  List,
  Edit,
  Datagrid,
  TextField,
  Create,
  SimpleForm,
  ReferenceField,
  DateField,
  DateInput,
  EditButton,
  Responsive,
  FunctionField,
  showNotification,
  required,
  SaveButton,
  link,
  Toolbar,
  DeleteButton
} from "react-admin";
import { SubmissionError } from 'redux-form';
import withStyles from "@material-ui/core/styles/withStyles";
import Divider from "@material-ui/core/Divider";
import Tabs from "@material-ui/core/Tabs";
import TabUp from "@material-ui/core/Tab";
import moment from "moment";
import { API_ROOT } from "../api-config";
import styled from "styled-components";
import AttachMoney from "@material-ui/icons/AttachMoney";
import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from "@material-ui/core";
import { getPermissionRole } from "../util";

// const VehiclePagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />

// const VehicleFilter = (props) => (
//     <Filter {...props}>
//         <TextInput label="Gps Name" source="licence_plate" alwaysOn />
//         <TextInput label="Licence Plate" source="vechicle_chassis" alwaysOn />
//     </Filter>
// );
const StyledButton = styled(Button)`
  background-color: #006faf;
  color: white;
  padding: 5px 15px;
  border-radius: 5px; 
  outline: 0;
  text-transform: uppercase;
  cursor: pointer;
  box-shadow: 0px 2px 2px lightgray;
  transition: ease background-color 250ms; 
  text-align: center;  

  &:hover {
    background-color: #283593;
  }

  &:disabled {
    cursor: default;
    opacity: 0.7;
  }
`;
const filterStyles = {
  status: { width: 150 }
};

const holdTypes = [
  { _id: 0, description: "Regular" },
  { _id: 1, description: "New Bike" },
  { _id: 2, description: "Break In" },
  { _id: 3, description: "Sale" }
];

const datagridStyles = {
  total: { fontWeight: "bold" }
};

class TabbedDatagrid extends React.Component {
  tabs = [
    { id: "1", name: "Vehicles" },
    { id: "2", name: "Gps" },
    { id: "3", name: "Seats" },
    { id: "4", name: "Jackets" },
    { id: "5", name: "Tankbags" },
    { id: "6", name: "Helmets" },
    { id: "7", name: "Gloves" }
  ];

  state = {
    vehicle: [],
    gps: [],
    seat: [],
    jacket: [],
    tankbag: [],
    helmet: [],
    glove: []
  };

  static getDerivedStateFromProps(props, state) {
    if (props.ids !== state[props.filterValues.hold_item_type]) {
      return { ...state, [props.filterValues.hold_item_type]: props.ids };
    }
    return null;
  }

  checkHoldType = holdType => {
    switch (holdType) {
      case 0:
        return "Regular";
      case 1:
        return "New Bike";
      case 2:
        return "Break In";
      case 3:
        return "Sale";
      default:
        break;
    }
  };

  handleChange = (event, value) => {
    const { filterValues, setFilters } = this.props;
    setFilters({ ...filterValues, hold_item_type: value });
  };

  render() {
    const { classes, filterValues, ...props } = this.props;
    return (
      <Fragment>
        <Tabs
          fullWidth
          centered
          value={filterValues.hold_item_type}
          indicatorColor="primary"
          onChange={this.handleChange}
        >
          {this.tabs.map(choice => (
            <TabUp key={choice.id} label={choice.name} value={choice.id} />
          ))}
        </Tabs>
        <Divider />
        <Responsive
          medium={
            <div>
              {filterValues.hold_item_type === "7" && (
                <Datagrid {...props} ids={this.state["7"]}>
                  <ReferenceField
                    label="Glove"
                    source="glove_id"
                    reference="gloves"
                    linkType={false}
                  >
                    <TextField source="model" />
                  </ReferenceField>
                  <DateField label="Start date" source="start_date" />
                  <DateField label="End date" source="end_date" />
                  <FunctionField
                    label="Hold Type"
                    render={hold => this.checkHoldType(hold.hold_type)}
                  />
                  {([1, 2, 3, 4, 6, 9].includes(getPermissionRole())) && ( 
                    <EditButton />
                  )}
                </Datagrid>
              )}
              {filterValues.hold_item_type === "6" && (
                <Datagrid {...props} ids={this.state["6"]}>
                  <ReferenceField
                    label="Helmet"
                    source="helmet_id"
                    reference="helmets"
                    linkType={false}
                  >
                    <TextField source="model" />
                  </ReferenceField>
                  <DateField label="Start date" source="start_date" />
                  <DateField label="End date" source="end_date" />
                  <FunctionField
                    label="Hold Type"
                    render={hold => this.checkHoldType(hold.hold_type)}
                  />
                  {([1, 2, 3, 4, 6, 9].includes(getPermissionRole())) && ( 
                    <EditButton />
                  )}
                </Datagrid>
              )}
              {filterValues.hold_item_type === "5" && (
                <Datagrid {...props} ids={this.state["5"]}>
                  <ReferenceField
                    label="Tankbag"
                    source="tankbag_id"
                    reference="tankbags"
                    linkType={false}
                  >
                    <TextField source="model" />
                  </ReferenceField>
                  <DateField label="Start date" source="start_date" />
                  <DateField label="End date" source="end_date" />
                  <FunctionField
                    label="Hold Type"
                    render={hold => this.checkHoldType(hold.hold_type)}
                  />
                {([1, 2, 3, 4, 6, 9].includes(getPermissionRole())) && ( 
                    <EditButton />
                  )}
                </Datagrid>
              )}
              {filterValues.hold_item_type === "4" && (
                <Datagrid {...props} ids={this.state["4"]}>
                  <ReferenceField
                    label="Jacket"
                    source="jacket_id"
                    reference="jackets"
                    linkType={false}
                  >
                    <TextField source="model" />
                  </ReferenceField>
                  <DateField label="Start date" source="start_date" />
                  <DateField label="End date" source="end_date" />
                  <FunctionField
                    render={hold => this.checkHoldType(hold.hold_type)}
                  />
                  {([1, 2, 3, 4, 6, 9].includes(getPermissionRole())) && ( 
                    <EditButton />
                  )}
                </Datagrid>
              )}
              {filterValues.hold_item_type === "3" && (
                <Datagrid {...props} ids={this.state["3"]}>
                  <ReferenceField
                    label="Seat"
                    source="seat_id"
                    reference="seats"
                    linkType={false}
                  >
                    <TextField source="model" />
                  </ReferenceField>
                  <DateField label="Start date" source="start_date" />
                  <DateField label="End date" source="end_date" />
                  <FunctionField
                    label="Hold Type"
                    render={hold => this.checkHoldType(hold.hold_type)}
                  />
                  {([1, 2, 3, 4, 6, 9].includes(getPermissionRole())) && ( 
                    <EditButton />
                  )}
                </Datagrid>
              )}
              {filterValues.hold_item_type === "2" && (
                <Datagrid {...props} ids={this.state["2"]}>
                  <ReferenceField
                    label="Gps Device"
                    source="gps_id"
                    reference="gps_devices"
                    linkType={false}
                  >
                    <TextField source="model" />
                  </ReferenceField>
                  <DateField label="Start date" source="start_date" />
                  <DateField label="End date" source="end_date" />
                  <FunctionField
                    label="Hold Type"
                    render={hold => this.checkHoldType(hold.hold_type)}
                  />
                  {([1, 2, 3, 4, 6, 9].includes(getPermissionRole())) && ( 
                    <EditButton />
                  )}
                </Datagrid>
              )}
              {filterValues.hold_item_type === "1" && (
                <Datagrid {...props} ids={this.state["1"]}>
                  <ReferenceField
                    label="Licence Plate"
                    source="vehicle_id"
                    reference="vehicles"
                    linkType={false}
                  >
                    <TextField source="licence_plate" />
                  </ReferenceField>

                  <ReferenceField
                    label="Vehicle Model"
                    source="vehicle_id"
                    reference="vehicles"
                    linkType={false}
                  >
                    <ReferenceField
                      addLabel={false}
                      source="vehicle_model_id"
                      reference="vehicle_models"
                      linkType={false}
                    >
                      <TextField source="model_name" />
                    </ReferenceField>
                  </ReferenceField>

                  <DateField label="Start date" source="start_date" />
                  <DateField label="End date" source="end_date" />
                  <FunctionField
                    label="Hold Type"
                    render={hold => this.checkHoldType(hold.hold_type)}
                  />
                  {([1, 2, 3, 4, 6, 9].includes(getPermissionRole())) && ( 
                    <EditButton />
                  )}
                </Datagrid>
              )}
            </div>
          }
        />
      </Fragment>
    );
  }
}

const StyledTabbedDatagrid = withStyles(datagridStyles)(TabbedDatagrid);

const CommandFilter = withStyles(filterStyles)(({ classes, ...props }) => (
  <Filter {...props}>
    <TextInput label="Licence Plate" source="licence_plate" alwaysOn />
    <TextInput label="Gps Model" source="gps_model" alwaysOn />
    <TextInput label="Seat Model" source="seat_model" alwaysOn />
    <TextInput label="Tankbag Model" source="tankbag_model" alwaysOn />
    <TextInput label="Glove Model" source="glove_model" alwaysOn />
    <TextInput label="Jacket Model" source="jacket_model" alwaysOn />
    <TextInput label="Helmet Model" source="helmet_model" alwaysOn />
  </Filter>
));

export const HoldList = ({ classes, ...props }) => (
  <List
    {...props}
    bulkActionButtons={false}
    filterDefaultValues={{ hold_item_type: "1" }}
    sort={{ field: "start_date", order: "DESC" }}
    perPage={25}
    filters={<CommandFilter />}
  >
    <StyledTabbedDatagrid />
  </List>
);

const HoldTitle = object => (
  <span>
    {" Edit "} &quot;{object.record.id}&quot;
  </span>
);

function Fecha(date){
  return moment.utc(date).locale('es').format('YYYY-MM-DD');
}

const HoldsEditToolbar = props => {
  return (
    <Toolbar {...props}>
      {([1, 2, 3, 4, 6, 9].includes(getPermissionRole())) && ( 
        <React.Fragment >
          <SaveButton {...props} redirect={`/holds`} />     
          <DeleteButton {...props}></DeleteButton>
        </React.Fragment>
      )}
    </Toolbar>
  )
};

export const HoldEdit = props => (
  <Edit title={<HoldTitle />} {...props}>
    <SimpleForm toolbar={<HoldsEditToolbar props={{ ...props }} /> }>
      <DateInput label="Start Date" source="start_date" locales="es-Es" options={{ timeZone: 'UTC' }} format={Fecha} />
      <DateInput label="End Date" source="end_date" locales="es-Es" options={{ timeZone: 'UTC' }} format={Fecha} />
      <ReferenceInput
        label="Gps"
        source="gps_id"
        reference="gps_devices"
        sort={{ field: "model", order: "ASC" }}
        perPage={1000}
      >
        <AutocompleteInput source="gps_id" optionText="model" perPage={1000} />
      </ReferenceInput>
      <ReferenceInput
        label="Vehicle (Licence Plate)"
        source="vehicle_id"
        reference="vehicles"
        sort={{ field: "licence_plate", order: "ASC" }}
        perPage={1000}
      >
        <AutocompleteInput
          source="vehicle_id"
          optionText={v => {
            return `${v.licence_plate} - ${v.model.model_name}`;
          }}
          perPage={1000}
        />
      </ReferenceInput>
      <ReferenceInput
        label="Seat"
        source="seat_id"
        reference="seats"
        sort={{ field: "model", order: "ASC" }}
        perPage={1000}
      >
        <AutocompleteInput source="seat_id" optionText="model" perPage={1000} />
      </ReferenceInput>
      <ReferenceInput
        label="Jacket"
        source="jacket_id"
        reference="jackets"
        sort={{ field: "model", order: "ASC" }}
        perPage={1000}
      >
        <AutocompleteInput
          source="jacket_id"
          optionText="model"
          perPage={1000}
        />
      </ReferenceInput>
      <ReferenceInput
        label="Helmet"
        source="helmet_id"
        reference="helmets"
        sort={{ field: "model", order: "ASC" }}
        perPage={1000}
      >
        <AutocompleteInput
          source="helmet_id"
          optionText="model"
          perPage={1000}
        />
      </ReferenceInput>
      <ReferenceInput
        label="Glove"
        source="glove_id"
        reference="gloves"
        sort={{ field: "model", order: "ASC" }}
        perPage={1000}
      >
        <AutocompleteInput
          source="glove_id"
          optionText="model"
          perPage={1000}
        />
      </ReferenceInput>
      <ReferenceInput
        label="Tankbag"
        source="tankbag_id"
        reference="tankbags"
        sort={{ field: "model", order: "ASC" }}
        perPage={1000}
      >
        <AutocompleteInput
          source="tankbag_id"
          optionText="model"
          perPage={1000}
        />
      </ReferenceInput>
      <SelectInput
        label="Hold Type"
        source="hold_type"
        choices={holdTypes}
        optionText="description"
        optionValue="_id"
        alwaysOn
      />
      <LongTextInput label="Comment" source="comment" />
    </SimpleForm>
  </Edit>    

);

function handleChangeStartDate (element, type) {
  if(element.target.id === "start_date"){
    //console.log('se cambio')
    const newDate2 = moment(element.target.value).add(1,'day').format("YYYY-MM-DD")
    const date2 = document.getElementById('end_date')
    date2.min = element.target.value
    date2.value = newDate2 
  }
}

const API_URL = API_ROOT; // URL de tu API

const api = {
  checkHoldAvailability: async (startDate, endDate, vehicleId) => {
    try {
      const response = await fetch(`${API_URL}/holdsExist?start_date=${startDate}&end_date=${endDate}&vehicle_id=${vehicleId}`);
      
      if (response.ok) {
        const data = await response.json();

       
       console.log(data.holds)
        // Verificar la respuesta de la API y devolver true o false según corresponda
        return data.holds;
      } else {
        // Manejar el error de la solicitud HTTP si es necesario
        throw new Error('Error al verificar la disponibilidad del hold');
      }
    } catch (error) {
      // Manejar el error de la solicitud HTTP si es necesario
      //throw new Error('Error al verificar la disponibilidad del hold');
    }
  },
};

export default api;
const HoldsToolbar = props => {
  return (
    <Toolbar {...props}>
      {([1, 2, 3, 4, 6, 9].includes(getPermissionRole())) && ( 
        <SaveButton redirect={`/holds`} />
      )}
    </Toolbar>
  )
};

;

export const HoldCreate = props => {
 // const existingHold = ;
  const [state, setState] = useState({
    showDialog: false,
    chargeValue: 0,
    generate_invoice: false,
    invoiceComments: '',
    imtComments: '',
    disabledSave: true,
    existingHold: [], 
  });
  const CustomListToolbar = props => (
    <Toolbar {...props} >
        {/* Aquí puedes agregar cualquier otro elemento que desees en la barra de herramientas */}
    </Toolbar>
  );

  const handleOpenDialog = () => {
    setState({ ...state, showDialog: true });
  };

  const handleCloseDialog = () => {
    setState({ ...state, showDialog: false });
  };

  const handleVehicleChange = (selectedVehicle) => {
    setState({ ...state, selectedVehicle, disabledSave: !selectedVehicle });
  };

  const atLeastOneRequired = (value, allValues, props, name) => {
    if (!allValues.gps_id && !allValues.vehicle_id) {
      return 'You must provide at least one GPS or one Vehicle.';
    }
    else if (state.existingHold && state.existingHold.length > 0) {
      return 'Holds created. New ones cannot be created.';
    }
  };

  const localDataProvider = (type, resource, params) => {
    
      return Promise.resolve({
        data: state.existingHold,
        total:  state.existingHold.length,
      });
    
  }
  const validateHold = async values => {

    try {
      // Resto de tu lógica de validación
      const startDate = values.start_date;
      const endDate = values.end_date;
      const vehicleId = values.vehicle_id;
      const gpsId = values.gps_id;
  

      // Ejemplo de validación ficticia
      const data = await api.checkHoldAvailability(startDate, endDate, vehicleId);
      if (data) {
        setState({ showDialog: true, existingHold: data }, () => {
          // Código que depende de existingHold actualizado
          handleOpenDialog();
        });

        throw new SubmissionError({
          vehicle_id: 'The vehicle is already booked for the specified date range.',
        });
      }
      else {
        setState({ showDialog: false, existingHold: [] });
      }
    } catch (error) {
      // Manejar el error de validación
      if (error instanceof SubmissionError) {
        // Puedes hacer algo con el error, como mostrar un mensaje al usuario
        console.error('Error de validación:', error.errors);
      } else {
        // Manejar otros errores que no sean de validación
        console.error('Error inesperado:', error);
      }
    }
   
  };
 return(
  <Create title="Create" {...props}>
    <SimpleForm 
      toolbar={<HoldsToolbar props={{ ...props }} />}
    validate={validateHold} >
      {/* <DateInput label="Start Date" source="start_date" /> */}
      <TextInput id="start_date"
            label="Start Date" type="date" name="start_date" source="start_date"
            onChange={e => handleChangeStartDate(e, "start_date")}
            defaultValue={moment(null).format("YYYY-MM-DD")} locales="es-Es" options={{ timeZone: 'UTC' }}
            InputLabelProps={{shrink: true }}
            validate={[required()]}
      />
      <DateInput label="End Date" source="end_date" locales="es-Es" options={{ timeZone: 'UTC' }} 
        validate={[required()]}
      />
      <ReferenceInput
        label="Gps "
        source="gps_id"
        reference="gps_devices"
        sort={{ field: "model", order: "ASC" }}
        perPage={1000}
        validate={[atLeastOneRequired]}
      >
        <AutocompleteInput source="gps_id" optionText={g => `${g.model}`} perPage={1000} />
      </ReferenceInput>
      <ReferenceInput
        label="Vehicle (Licence Plate)"
        source="vehicle_id"
        reference="vehicles"
        sort={{ field: "licence_plate", order: "ASC" }}
        perPage={1000}
        validate={[atLeastOneRequired]}
      >
        <AutocompleteInput
          source="vehicle_id"
          optionText={v => {
            return `${v.licence_plate} - ${v.model.model_name}`;
          }}
          perPage={1000}
        />
      </ReferenceInput>
      <ReferenceInput
        label="Seat"
        source="seat_id"
        reference="seats"
        sort={{ field: "model", order: "ASC" }}
        perPage={1000}
      >
        <AutocompleteInput source="seat_id" optionText="model" perPage={1000} />
      </ReferenceInput>

      <ReferenceInput
        label="Jacket"
        source="jacket_id"
        reference="jackets"
        sort={{ field: "model", order: "ASC" }}
        perPage={1000}
      >
        <AutocompleteInput
          source="jacket_id"
          optionText="model"
          perPage={1000}
        />
      </ReferenceInput>
      <ReferenceInput
        label="Helmet"
        source="helmet_id"
        reference="helmets"
        sort={{ field: "model", order: "ASC" }}
        perPage={1000}
      >
        <AutocompleteInput
          source="helmet_id"
          optionText="model"
          perPage={1000}
        />
      </ReferenceInput>
      <ReferenceInput
        label="Glove"
        source="glove_id"
        reference="gloves"
        sort={{ field: "model", order: "ASC" }}
        perPage={1000}
      >
        <AutocompleteInput
          source="glove_id"
          optionText="model"
          perPage={1000}
        />
      </ReferenceInput>
      <ReferenceInput
        label="Tankbag"
        source="tankbag_id"
        reference="tankbags"
        sort={{ field: "model", order: "ASC" }}
        perPage={1000}
      >
        <AutocompleteInput
          source="tankbag_id"
          optionText="model"
          perPage={1000}
        />
      </ReferenceInput>
      <SelectInput
        label="Hold Type"
        source="hold_type"
        choices={holdTypes}
        optionText="description"
        optionValue="_id"
        alwaysOn
        validate={[required()]}
      />
      <LongTextInput label="Comment" source="comment" />

      <Fragment>
      <Dialog
  fullWidth={true}
  maxWidth={"md"}
  open={state.showDialog}
  onClose={handleCloseDialog}
  aria-label="Holds"
  PaperProps={{
    style: {
    //  backgroundColor: '#2C3E50', // Amarillo oscuro
      color: 'white', // Color del texto
    },
  }}
>
  <DialogTitle>
   Holds Createds
  </DialogTitle>
  <DialogContent>
    {console.log('Existing Holds:', state.existingHold)}
    <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
    <thead style={{ backgroundColor: '#FF9800' }}>
      <tr>
        <th > ID</th>
        <th >Start Date</th>
        <th>End Date</th>
        <th >Comment</th>
        {/* Agrega más encabezados según sea necesario */}
      </tr>
    </thead>
    <tbody>
    {state.existingHold.map((hold) => (
        <tr key={hold.id} style={{ borderBottom: '1px solid #ddd' }}>
        <td style={{ color: '#000000',textAlign: 'center' }}>{hold.id}</td>
        <td style={{ color: '#000000',textAlign: 'center' }}>{new Date(hold.start_date).toLocaleDateString()}</td>
        <td style={{ color: '#000000',textAlign: 'center' }}>{new Date(hold.end_date).toLocaleDateString()}</td>
        <td style={{ color: '#000000',textAlign: 'center' }}>{hold.comment !== null ? hold.comment : 'N/A'}</td>
        {/* Agrega más celdas según sea necesario */}
      </tr>
      
      ))}
    </tbody>
  </table>
  </DialogContent>
  <DialogActions>
    <StyledButton onClick={handleCloseDialog}>
      Cancel
    </StyledButton>
  </DialogActions>
</Dialog>


      </Fragment>
    </SimpleForm>
  </Create>
);
        };



// WEBPACK FOOTER //
// ./src/resources/holds.js